export enum NotificationFilterTypeEnum {
    QuizWindowOpened = 1,
    QuizWindowClosed = 2,
    AssessmentWindowOpened = 3,
    AssessmentWindowClosed = 4,
    InstitutionBulkEnrollmentComplete = 5,
    FacultyBulkImportComplete = 6
}

export enum NotificationTypeColorEnum {
    All = '',
    Tasks = 'text-success',
    Insights = 'text-purple-light',
    Notices = 'text-warning'
}

export enum NotificationStatusEnum {
    AllStatuses = 0,
    New = 1,
    Read = 2,
    Starred = 3,
    Deleted = 4
}

export enum NotificationTypeEnum {
    All = 0,
    Tasks = 1,
    Insights = 2,
    Notices = 3,
    // member only
    BottomLine = 4
}
